import React, { useEffect, useState } from "react";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Radio,
  Typography
} from "@material-ui/core";
import { toast } from "react-toastify";

import toastError from "../../errors/toastError";
import api from "../../services/api";

const SendMessageAttachmentToOsDialog = ({
  open,
  onClose,
  ticketId,
  message
}) => {
  const [links, setLinks] = useState([]);
  const [selectedOsId, setSelectedOsId] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!open || !ticketId) return undefined;
    let active = true;

    const loadLinks = async () => {
      setLoading(true);
      setSelectedOsId("");
      try {
        const { data } = await api.get(`/tickets/${ticketId}/os`);
        if (active) setLinks(data.data || []);
      } catch (err) {
        if (active) toastError(err);
      } finally {
        if (active) setLoading(false);
      }
    };

    loadLinks();
    return () => {
      active = false;
    };
  }, [open, ticketId]);

  const submit = async () => {
    if (!selectedOsId) return;
    setSubmitting(true);
    try {
      await api.post(
        `/tickets/${ticketId}/os/${selectedOsId}/anexos-chat`,
        { message_ids: [message.id] }
      );
      toast.success(`Anexo enviado para a OS #${selectedOsId}.`);
      onClose();
    } catch (err) {
      toastError(err);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onClose={submitting ? undefined : onClose} fullWidth maxWidth="sm">
      <DialogTitle>Enviar anexo para uma OS</DialogTitle>
      <DialogContent dividers>
        {loading ? (
          <div style={{ textAlign: "center", padding: 24 }}>
            <CircularProgress />
          </div>
        ) : links.length ? (
          <List>
            {links.map(link => (
              <ListItem
                key={link.id}
                button
                selected={String(selectedOsId) === String(link.osId)}
                onClick={() => setSelectedOsId(link.osId)}
              >
                <ListItemIcon>
                  <Radio
                    color="primary"
                    checked={String(selectedOsId) === String(link.osId)}
                  />
                </ListItemIcon>
                <ListItemText
                  primary={`OS #${link.osId}`}
                  secondary={
                    link.ordem?.descricao_curta || "Detalhes indisponíveis"
                  }
                />
              </ListItem>
            ))}
          </List>
        ) : (
          <Typography color="textSecondary">
            Este atendimento ainda não está vinculado a nenhuma OS. Faça o
            vínculo pelo menu do atendimento antes de enviar o anexo.
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={submitting}>
          Cancelar
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={submit}
          disabled={!selectedOsId || submitting}
        >
          {submitting ? <CircularProgress size={20} /> : "Enviar para OS"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SendMessageAttachmentToOsDialog;
